import { Geometry } from "react-migration/domains/sites/typings/Geometry";
import ROUTES from "src/js/router/routes";
import { SelectionType } from "src/js/stores/map/store";
import { calculateZoomLevel } from "./calculateZoomLevel";

type getMapSiteSelectionRouterLocationProps = {
  siteLatLng: {
    lat: number;
    lng: number;
  };
  geometry?: Geometry;
  siteId: string;
  isShared?: boolean;
};

type MapSiteSelectionLocation = {
  name: string;
  params: { z: string; x: string; y: string };
  query: {
    selectionType: SelectionType;
    selectionId: string;
  };
};

export const getMapSiteSelectionLocation = ({
  siteLatLng,
  geometry,
  siteId,
  isShared = false,
}: getMapSiteSelectionRouterLocationProps): MapSiteSelectionLocation => {
  const zoomLevel = geometry ? calculateZoomLevel(geometry) : 17;

  return {
    name: ROUTES.MAP,
    query: {
      selectionType: isShared ? SelectionType.SHARED_SITE : SelectionType.SITE,
      selectionId: siteId!,
    },
    params: {
      z: String(zoomLevel + 1),
      x: String(siteLatLng.lat),
      y: String(siteLatLng.lng),
    },
  };
};
